export const combineMealName = (mealName, mealSubtitle) => {
  if (mealSubtitle.length > 0) {
    return mealName + " " + mealSubtitle;
  } else {
    return mealName;
  }
};
